import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";

import styles from "../../Styles";
import { formatDisplayValue } from "../../helpers";

const COLUMN_WIDTHS = ["12%", "18%", "8%", "8%", "22%", "14%", "18%"];

const formatDate = (dateUtils, value) => {
    if (!value) {
        return "-";
    }

    return dateUtils.convertDateToDate(value, INTERNATIONAL_DATE_FORMAT);
};

const resolveManagerName = (manager = {}) => {
    return [
        manager?.title,
        manager?.fullName || manager?.name,
        manager?.lastName,
    ].filter(Boolean).join(" ").trim() || "-";
};

const ExternalManagementTable = ({ t, teamManagement = [] }) => {
    const dateUtils = new DateUtils();
    const managers = Array.isArray(teamManagement) ? teamManagement : [];

    const headerCellStyle = {
        ...styles.tableColHeader,
        ...styles.wordTableHeaderCell,
    };

    const headerTextStyle = {
        ...styles.tableCell,
        ...styles.fontBold,
        ...styles.wordTableHeaderText,
    };

    const renderHeaderCell = (label, width, isLast = false) => (
        <View
            style={{
                ...headerCellStyle,
                width,
                ...(isLast ? styles.borderRightNone : {}),
            }}
        >
            <Text style={headerTextStyle}>{t(label)}</Text>
        </View>
    );

    const renderBodyCell = (value, width, isLast = false) => (
        <View
            style={{
                ...styles.tableCol,
                width,
                ...(isLast ? styles.borderRightNone : {}),
            }}
        >
            <Text style={styles.tableCell}>{formatDisplayValue(value)}</Text>
        </View>
    );

    return (
        <View style={{ ...styles.table, width: "100%" }}>
            <View style={styles.tableRow}>
                {renderHeaderCell("Title", COLUMN_WIDTHS[0])}
                {renderHeaderCell("Name", COLUMN_WIDTHS[1])}
                {renderHeaderCell("Gender", COLUMN_WIDTHS[2])}
                {renderHeaderCell("ID", COLUMN_WIDTHS[3])}
                {renderHeaderCell("Position", COLUMN_WIDTHS[4])}
                {renderHeaderCell("Date of Birth", COLUMN_WIDTHS[5])}
                {renderHeaderCell("Appointed On", COLUMN_WIDTHS[6], true)}
            </View>

            {managers.length ? managers.map((manager, index) => {
                const rowStyle = {
                    ...styles.tableRow,
                    ...(index === managers.length - 1 ? styles.tableLastRow : {}),
                };

                return (
                    <View style={rowStyle} key={manager?.id || `manager-${index}`}>
                        {renderBodyCell(manager?.title || "Executive", COLUMN_WIDTHS[0])}
                        {renderBodyCell(resolveManagerName(manager), COLUMN_WIDTHS[1])}
                        {renderBodyCell(manager?.gender, COLUMN_WIDTHS[2])}
                        {renderBodyCell(manager?.id || manager?.secondaryId, COLUMN_WIDTHS[3])}
                        {renderBodyCell(manager?.position, COLUMN_WIDTHS[4])}
                        {renderBodyCell(
                            formatDate(dateUtils, manager?.dateOfBirth || manager?.birthDate),
                            COLUMN_WIDTHS[5]
                        )}
                        {renderBodyCell(
                            formatDate(dateUtils, manager?.appointmentDate || manager?.appointedOn || manager?.createdAt),
                            COLUMN_WIDTHS[6],
                            true
                        )}
                    </View>
                );
            }) : (
                <View style={{ ...styles.tableRow, ...styles.tableLastRow }}>
                    {renderBodyCell(t("No Data"), COLUMN_WIDTHS[0])}
                    {renderBodyCell("-", COLUMN_WIDTHS[1])}
                    {renderBodyCell("-", COLUMN_WIDTHS[2])}
                    {renderBodyCell("-", COLUMN_WIDTHS[3])}
                    {renderBodyCell("-", COLUMN_WIDTHS[4])}
                    {renderBodyCell("-", COLUMN_WIDTHS[5])}
                    {renderBodyCell("-", COLUMN_WIDTHS[6], true)}
                </View>
            )}
        </View>
    );
};

export default withNamespaces()(ExternalManagementTable);
